import React, { FC, useContext, useEffect, useState, useRef, ChangeEvent } from "react";
import styles from './cropcard.module.css';
import Cropper from "react-easy-crop";
import Slider from '@mui/material/Slider'
import faceFrom from '../../images/face_form_1.png'
import { getCroppedImage } from "../../utils/getCroppedImage";
import faceInput_1 from '../../images/faceInputs/faceInput_1.png';
import faceInput_2 from '../../images/faceInputs/faceInput_2.png';
import faceInput_3 from '../../images/faceInputs/faceInput_3.png';
import faceInput_4 from '../../images/faceInputs/faceInput_4.png';
import ModeIcon from '@mui/icons-material/Mode';
import DeleteIcon from '@mui/icons-material/Delete';
import ContentCutIcon from '@mui/icons-material/ContentCut';
import { Button, IconButton } from "@mui/material";

interface ICropcard {
    checkCropImage: (id: number, status: boolean, src: string) => void;
    handleCheckDeleteImages: (imageToDelete: string) => void;
    id: number;
    number: number;
}

export const Cropcard: FC<ICropcard> = ({checkCropImage, id, number, handleCheckDeleteImages}) => {

    const inputRef = useRef<any>(null)
    const [userImage, setUserImage] = useState<string | null>(null);
    const [croppedImage, setCroppedImage] = useState<string | null>(null);

    const [crop, setCrop] = useState({ x: 0, y: 0 });
    const [zoom, setZoom] = useState(2);
    const [ rotation, setRotation ] = useState(0)
    const [croppedAreaPixels, setCroppedAreaPixels] =
    useState<{ x: number; y: number; width: number; height: number } | null>(null);
    const [isOptionsActive, setIsOptionsActive] = useState<boolean>(false)

    const handleUploadUserImage = (e: ChangeEvent<HTMLInputElement>) => {
        const file = e.target?.files?.[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setUserImage(reader.result as string);
            };
            reader.readAsDataURL(file);
        }
    };

    const onCropComplete = (croppedArea: any, croppedAreaPixels: { x: number; y: number; width: number; height: number }) => {
        // console.log(croppedArea, croppedAreaPixels, rotation);
        setCroppedAreaPixels(croppedAreaPixels);
    };

    const handleCrop =  async() => {
        if (userImage && croppedAreaPixels) {
           const cropImg = await getCroppedImage(userImage, croppedAreaPixels)
           setCroppedImage(cropImg)
        }
    };

    const handleDeleteUserImage = async() => {
        // console.log(userImage)
        croppedImage && await handleCheckDeleteImages(croppedImage)
        setCroppedImage(null)
        setUserImage(null)
    }

    const handleActiveOptions = () => {
        setIsOptionsActive(!isOptionsActive)
    }


    const triggerClickInput = () => inputRef?.current?.click();

    useEffect(() => {
        if (croppedImage) {
            checkCropImage(id, true, croppedImage); 
        }
    }, [croppedImage]);


    const faceInputs = [
        faceInput_1,
        faceInput_2,
        faceInput_3,
        faceInput_4,
    ];

    return (
        // <div className={styles.cropContainer}>
        <>
            {croppedImage ? croppedImage && (
                <div style={{position: 'relative'}}>
                        <IconButton 
                        sx={{
                            position: 'absolute',
                            top: '-50px',
                            left: '1px',
                        }}
                        onClick={() => setCroppedImage(null)}
                        className={styles.btnChange} 
                        aria-label="modeIcon">
                            <ModeIcon className={styles.btnChange}/>
                        </IconButton>
                        <IconButton 
                        sx={{
                            position: 'absolute',
                            top: '-50px',
                            right: '1px',
                        }}
                        onClick={handleDeleteUserImage}
                        className={styles.btnDelete} aria-label="delete">
                            <DeleteIcon className={styles.btnDelete}/>
                        </IconButton>
                    <img className={styles.imageCrop} src={faceFrom} alt="Форма" />
                    <img className={styles.croppedImage} src={croppedImage} alt="Обрезанное" />
                </div>
            ) : userImage ? userImage && (
                <div className={styles.cropperContainer}>
                    <div className={styles.btnContainer}>
                        <Button 
                        sx={{
                            backgroundColor: '#74bb44',
                            border: '2px solid #FFF',
                            borderRadius: '10px'
                        }}
                        className={styles.btnCutImage} 
                        variant="contained"
                        onClick={handleCrop} 
                        endIcon={<ContentCutIcon />}>
                            Обрезать изображение
                        </Button>
                    </div>
                    <div className={styles.cropper}>
                        <img className={styles.imageCropper} src={faceFrom} alt="Форма" />
                        <Cropper
                            image={userImage}
                            crop={crop}
                            cropSize={{ width: 228, height: 286 }}
                            zoom={zoom}
                            rotation={rotation}
                            aspect={1} 
                            onCropChange={setCrop}
                            onZoomChange={setZoom}
                            onCropComplete={onCropComplete}
                            cropShape={'round'}
                            showGrid={false}
                        />
                        <Slider
                            style={{
                                position: 'absolute',
                                top: '20px',
                                left: '10%',
                                width: '80%'
                            }}
                            className={styles.sliderSlide}
                            min={1}
                            max={9}
                            step={0.1}
                            value={zoom}
                            onChange={(e, zoom) => setZoom(zoom as number)}
                        />
                        {/* <Slider 
                            className={styles.sliderSlide}
                              min={1}
                              step={0.1}
                              max={360}
                              value={rotation}
                              onChange={(e, rotation) => setRotation(rotation as number)}
                            /> */}
                    </div>
                    {/* {
                        isOptionsActive && (
                            <div className={styles.slider}>
                            <Slider
                                className={styles.sliderSlide}
                                min={1}
                                max={9}
                                step={0.1}
                                value={zoom}
                                onChange={(e, zoom) => setZoom(zoom as number)}
                            />
                        </div>
                        )
                    } */}
                </div>
            ) : <>
                <input 
                ref={inputRef}
                type="file" 
                accept="image/*" 
                onChange={handleUploadUserImage} 
                style={{display: 'none'}}
            />
            <img
            onClick={triggerClickInput}
            className={styles.inputImage}
            src={faceInputs[number - 1]} 
            alt="Нажмите, чтобы выбрать изображение" />
            </>}
            </>
        // </div>
    );
};
